// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../styles/_colors.css\"","light-grey":"#9eabbc","dark-grey":"#475166","icon-selected":"#46a7f6","nav":"ProductNav_nav__r0Fog","selected":"ProductNav_selected__2uyqQ"};